export const TASK_STATUSES = [
    { label: 'Unhandled', value: 0, count: 1, color: '#0074cc' },       // Blue
    { label: 'Completed', value: 1, count: 2, color: '#ff8800' },  // Orange
    { label: 'Progress', value: 2, count: 2, color: '#2eb82e' },  // Green
    { label: 'Overdue', value: 3, count: 1, color: '#e63946' },   // Red
  ];